// @flow

import EventEmitter from 'events';
import * as CountryLocalActionTypes from 'action_types/CountryLocalActionTypes';
import Dispatcher from 'dispatcher';

const CHANGE = 'change';

let _codes = [];

class CountryLocalStore extends EventEmitter {
  constructor(): void {
    super();
    Dispatcher.register(this._actionsHandler);
  }

  getCodes = (): any => {
    const codesSorted = _codes.sort((code, prevCode) => {
      if (code.label > prevCode.label) {
        return 1;
      }

      if (code.label < prevCode.label) {
        return -1;
      }

      return 0;
    });
    return codesSorted;
  };

  getCodeByValue = (value: string): any => {
    return _codes.find(code => code.value === value);
  };

  addChangeListener = (callback: () => void) => {
    this.on(CHANGE, callback);
  };

  removeChangeListener = (callback: () => void) => {
    this.removeListener(CHANGE, callback);
  };

  _setCodes = (codes: {}[]) => {
    _codes = codes.map(({ value, display }: any) => ({
      value,
      label: display
    }));
  };

  _emitChange = () => {
    this.emit(CHANGE);
  };

  _actionsHandler = (action: any) => {
    switch (action.type) {
      case CountryLocalActionTypes.SAVE_COUNTRY_CODES: {
        this._setCodes(action.codes);
        this._emitChange();
        break;
      }
    }
  };
}

export default new CountryLocalStore();
